import { selectSelectionsForSelectedReport } from 'app/area/favourite/selectors';
import { mapToSelectionValue } from 'app/area/reports/containers/group-by/map-to-store';
import { selectGroupByFieldState } from 'app/area/reports/selectors';
import { ApplicationState } from 'app/types-store';

export const selectSelectionFieldItemsForCurrentReport = (instanceKey: string) => (state: ApplicationState) => {
  const {
    selections,
    rollingAverage
  } = selectSelectionsForSelectedReport(instanceKey)(state);

  const groupByFieldState = selectGroupByFieldState(instanceKey)(state);

  return selections
    ?.map((s, i) => mapToSelectionValue(s, i === 0 ? rollingAverage : undefined))
    ?.map(s => ({
      ...s,
      field: {
        ...s.field,
        showMissingValues: groupByFieldState?.selectionTypeInformation?.[s?.field?.value]?.showMissingValues
      },
      selectionTypes: groupByFieldState?.selectionTypeInformation?.[s?.field?.value]?.selectionTypes
    })) ?? [];
};
